// Helper: identify PECB-certified courses by title/category pattern.
// Mirrors backend/services/pecb.py heuristic.

export const PECB_SIGNUP_URL = "https://mypecb.com";

export const courseRequiresPecb = (course) => {
  if (!course) return false;
  const title = (course.title || "").toLowerCase();
  const category = (course.category || "").toLowerCase();
  if (title.startsWith("iso ")) return true;
  if (title.includes("pecb") || category.includes("pecb")) return true;
  return false;
};
